import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {LabeledInputComponent} from "../../../shared/labeled-input/labeled-input.component";
import {NgSelectComponent, NgSelectModule} from "@ng-select/ng-select";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {CustomerService} from "../../../_services/customer.service";
import {Customer} from "../../../_models/Customer";
import {LabeledDisplayComponent} from "../../../shared/labeled-display/labeled-display.component";

@Component({
  standalone: true,
  templateUrl: './my-details.component.html',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    RouterModule,
    LabeledDisplayComponent
  ],
  encapsulation: ViewEncapsulation.None
})

export class MyDetailsComponent implements OnInit{

  constructor(private customerService: CustomerService) {
  }

  selectedCustomerId: number;
  selectedCustomer: Customer;

  ngOnInit() {
    this.getCustomers();
  }

  public customers: Customer[] = [];

  getCustomers() {
    this.customerService.getCustomersByUser()
      .subscribe(customers => {
        this.customers = customers;
      })
  }

  displayCustomer() {
    this.selectedCustomer = this.customers.find(x => x.id === this.selectedCustomerId);
    return;
  }
}
